export function getServiceTag(): string {
  const c = document.cookie.split("; ").find(s => s.startsWith("servicetag"));
  return c ? c.split("=")[1] : "";
}